import { css } from 'aphrodite';
import { ComboboxItem, ComboboxItemIndicator } from '.';
import { Avatar2 } from '../../components/Avatar2';
import { bs } from '../../styles/styles';

interface Props extends React.ComponentProps<typeof ComboboxItem> {
	avatarImageUrl: string;
	avatarFallbackText?: string;
	title: string;
	description?: string;
}

export function ComboboxAvatarItem({ avatarImageUrl, avatarFallbackText, title, description, ...props }: Props) {
	return (
		<ComboboxItem {...props}>
			<ComboboxItemIndicator />
			<div className={css(bs.flex, bs.itemsCenter, bs.gap2, bs.truncateText)}>
				<Avatar2 imgSrc={avatarImageUrl} fallbackText={avatarFallbackText} styles={[bs.w10, bs.h10]} />
				<div className={css(bs.flex1, bs.minW0)}>
					<div className={css(bs.fontBold, bs.truncateText)}>{title}</div>
					{description ? (
						<div className={css(bs.textSm, bs.textDarkGrayFontColor, bs.truncateText)}>{description}</div>
					) : null}
				</div>
			</div>
		</ComboboxItem>
	);
}
